// extracted by mini-css-extract-plugin
module.exports = {"root":"Table_root__3laR2","head":"Table_head__esdHa","col":"Table_col__2I92F"};